export default __webpack_public_path__ + "static/media/apple-alt.edf44cf1.svg";